<template>
    <!-- 预览试卷 -->
    <paperPreview :paperPreview="true"></paperPreview>
</template>

<script>
import paperPreview from '@/components/paperPreview/index.vue'
export default {
    components: {
        paperPreview
    },
}
</script>
